export const OL_SERVICE = {
  SERVICE_NAME: 'UPSIDER キャッシュブースト',
} as const
